import { NotificationTopic } from 'Generated/schema';
import * as Yup from 'yup';

import { NotificationsIcons } from './types';
import { NotificationPreferences } from './graphql/NotificationPreferences.generated';

export const notificationsIcons: NotificationsIcons = {
  INFO: { type: 'notifications-info', color: 'blue-500' },
  WARNING: { type: 'notifications-warning', color: 'yellow-600' },
  ERROR: { type: 'notifications-error', color: 'red-600' },
};

export enum NotificationTitleEnum {
  INGESTION_CAPACITY_LIMIT = 'Ingestion capacity limit',
  INGESTION_CAPACITY_LIMIT_REACHED = 'Monthly ingestion quota exceeded',
  SOURCE_NO_DATA = 'Source has not received events',
  SOURCE_PERMISSIONS_CHECKS_FAILED = 'Permission checks for source have failed',
  SYSTEM_ERROR = 'System Error Alert',
}

export const PREFERENCES_COPIES = {
  [NotificationTopic.SystemNotification]: {
    title: 'System Notifications',
    description: 'System notifications related to your Panther instance',
  },
  [NotificationTopic.SystemError]: {
    title: 'System Errors',
    description: 'System errors related to your Panther instance',
  },
  [NotificationTopic.DetectionNotification]: {
    title: 'Detection Notifications',
    description: "Notifications related to Panther's detection processing",
  },
};

export const CHANNELS_NAMES = {
  IN_APP: 'Enable in-app notifications',
};

export const validationSchema = Yup.object().shape({
  preferences: Yup.array().of(
    Yup.object().shape({
      topic: Yup.string().required(),
      channels: Yup.array().of(
        Yup.object().shape({
          name: Yup.string().required(),
          enabled: Yup.boolean().required(),
        }),
      ),
    }),
  ),
});

export const originalPreferences: NotificationPreferences['notificationPreferences'] = {
  preferences: [
    {
      topic: NotificationTopic.SystemNotification,
      channels: [
        {
          name: 'IN_APP',
          enabled: true, // This is the default value
        },
      ],
    },
    {
      topic: NotificationTopic.SystemError,
      channels: [
        {
          name: 'IN_APP',
          enabled: true, // This is the default value
        },
      ],
    },
    {
      topic: NotificationTopic.DetectionNotification,
      channels: [
        {
          name: 'IN_APP',
          enabled: true, // This is the default value
        },
      ],
    },
  ],
};
